"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ValueCreatingServicesHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="tjänster-som-skapar-värde" className="relative w-full bg-secondary/40 py-24 md:py-32 lg:py-40 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none flex justify-center">
        <div className="w-full max-w-5xl h-full bg-gradient-to-b from-background/0 via-background/50 to-background/0 opacity-50" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <div ref={ref} className={`flex flex-col items-center text-center mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground max-w-4xl text-balance">
            Tjänster som skapar <span className="text-primary">värde</span> och driver <span className="text-primary">tillväxt</span>
          </h1>
          
          <p className="mt-6 text-lg md:text-xl text-muted-foreground max-w-[600px] text-balance leading-relaxed">
            Vi är din personliga partner inom ekonomi. Med skräddarsydda lösningar, 
            närhet till din verksamhet och strategisk rådgivning hjälper vi ditt företag 
            att nå sin fulla potential.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto group">
              <Link to="/ContactPage">
                Boka kostnadsfri rådgivning
                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
              <Link to="/AboutUsPage">
                Lär känna oss
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}